<template>
    <UsersNetworkModal
        v-model="form"
        @onConfirm="onClickConfirm"
        :is-loading="isLoading"
        :title="$t('values.updatingNetworks')"
        :btn-confirm-text="$t('dashboard.refresh')"
        translation="1"
    />
</template>

<script>
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import updateUsersNetworks from './api'
import { noSelectedUsersAlert, onlyAdministratorFunctionAlert } from '../../alerts'
import UsersNetworkModal from '../users-network-modal/UsersNetworkModal'

export default {
    name: 'UpdateUsersNetworks',
    components: {
        UsersNetworkModal,
    },
    props: {
        users: {
            type: Array,
            default: () => [],
        },
        canUpdateUsersNetworks: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                updateLeader: false,
                updateTeam: false,
                updatePeers: false,
            },
            isLoading: false,
        }
    },
    mounted() {
        if (!this.canUpdateUsersNetworks) {
            this.handlerUserWithoutAuthorization()
            return
        }

        if (!this.users.length) {
            this.handlerNoUsersSelecteds()
        }
    },
    methods: {
        onClickConfirm(routerBack, success, error) {
            Swal.queue([
                {
                    type: 'warning',
                    title: i18n.t('notification.warning'),
                    text: i18n.t('notification.updateUsersNetwork'),
                    confirmButtonText: i18n.t('notification.yes'),
                    confirmButtonColor: '#20A8D8',
                    cancelButtonText: i18n.t('notification.no'),
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    preConfirm: () => {
                        this.isLoading = true
                        updateUsersNetworks(
                            this.users,
                            this.form.updateLeader,
                            this.form.updateTeam,
                            this.form.updatePeers
                        )
                            .then(() => {
                                success()
                            })
                            .catch(() => {
                                error()
                            })
                            .finally(() => {
                                this.isLoading = false
                                routerBack()
                            })
                    },
                },
            ])
        },
        handlerUserWithoutAuthorization() {
            return onlyAdministratorFunctionAlert().then(() => this.routerBack())
        },
        handlerNoUsersSelecteds() {
            return noSelectedUsersAlert().then(() => this.routerBack())
        },
    },
}
</script>
